import site from '../../site';
import errors from '../../errors';
import installScript from '../helpers/install-script';
import composeExtensionAssetUrl from '../helpers/compose-extension-asset-url';
import applyStyles from '../helpers/apply-styles';
import operations from '../operations';
import registry from '../helpers/registry';
import getExtensionConfigurations from '../selectors/extension-configurations';
// dev-extension-import-token

const extensionLoader = (store) => (next) => (action) => {
  switch (action.type) {
    case site.actionTypes.CONNECT_SITE: {
      const state = store.getState();
      const connectedExtensions = getExtensionConfigurations(state);

      if (!connectedExtensions) {
        next(action);
        return;
      }
      const extensionPromises = connectedExtensions.map((extension) => {
        // We are detecting Internal Extensions by missing "version" field,
        // they will be registered immediately in case there is such an extension in the extension registry

        if (!extension.version) {
          if (!registry.has(extension.slug)) {
            console.error(`There is no extension with slug: ${extension.slug} in the registry`);

            return Promise.resolve();
          }

          const extensionToRegister = registry.get(extension.slug);
          operations.registerExtension(extensionToRegister);
          if (extensionToRegister.init) {
            extensionToRegister.init();
          }
          return Promise.resolve();
        }
        // dev-extension-inject-content-token
        const scriptUrl = composeExtensionAssetUrl(extension.slug, extension.mainSource);
        const sources = [installScript(scriptUrl)];

        if (extension.stylesSource) {
          const stylesUrl = composeExtensionAssetUrl(extension.slug, extension.stylesSource);
          sources.push(applyStyles(stylesUrl));
        }

        return Promise.all(sources);
      });

      Promise.all(extensionPromises)
        .then(() => {
          next(action);
        })
        .catch((error) => {
          errors.operations.catchError(error);
        });

      break;
    }

    default:
      next(action);
  }
};

export default extensionLoader;
